import produce from 'immer';
import { EntityTypePrefix } from './constants';
export const actionTypes = {
    LOADING_CHANGED: 'LOADING_CHANGED',
    VIEW_CHANGED: 'VIEW_CHANGED',
    DATE_CHANGED: 'DATE_CHANGED',
    DETAILED_TOGGLED: 'DETAILED_TOGGLED',
    FILTER_CHANGED: 'FILTER_CHANGED',
    FILTER_TOGGLED: 'FILTER_TOGGLED',
    TECH_TOGGLED: 'TECH_TOGGLED',
    STATUS_TOGGLED: 'STATUS_TOGGLED',
    DATA_ADDED: 'DATA_ADDED',
    DATA_CHANGED: 'DATA_CHANGED',
    MULTI_DATA_CHANGED: 'MULTI_DATA_CHANGED',
    DATA_LOADED: 'DATA_LOADED',
    MULTI_DATA_DELETED: 'MULTI_DATA_DELETED',
    NETWORK_REQUEST_FAILED: 'NETWORK_REQUEST_FAILED',
    UNSELECT_ALL_TECHS: 'UNSELECT_ALL_TECHS',
    SELECT_ALL_TECHS: 'SELECT_ALL_TECHS',
    SET_TECHNICIANS: 'SET_TECHNICIANS',
    SET_SUBCONTRACTORS: 'SET_SUBCONTRACTORS',
    UPDATE_TECHNICIANS: 'UPDATE_TECHNICIANS',
    UNSELECT_ALL_STATUSES: 'UNSELECT_ALL_STATUSES',
    UNSELECT_ALL_INSPECTION_STATUSES: 'UNSELECT_ALL_INSPECTION_STATUSES',
    UNSELECT_ALL_VISIT_STATUSES: 'UNSELECT_ALL_VISIT_STATUSES',
    SELECT_ALL_STATUSES: 'SELECT_ALL_STATUSES'
};
export const reducer = produce((draft, action) => {
    switch (action.type) {
        case actionTypes.VIEW_CHANGED:
            draft.view = action.view;
            break;
        case actionTypes.DATE_CHANGED:
            draft.range = action.range;
            draft.loading = true;
            break;
        case actionTypes.DETAILED_TOGGLED:
            draft.detailed = !draft.detailed;
            break;
        case actionTypes.FILTER_CHANGED:
            if (action.filters) {
                // No-op if nothing changed at all.
                if (JSON.stringify(draft.filters) === JSON.stringify(action.filters))
                    return;
                // Only trigger a re-fetch (loading=true) when the actual filter VALUES change.
                // If only `active` flags changed (e.g. toggling the filter panel open/closed while
                // the value is still empty), the query key is identical so no fetch would happen
                // and loading would be stuck forever.
                const valuesChanged = JSON.stringify(draft.filters.values) !== JSON.stringify(action.filters.values);
                draft.filters = action.filters;
                if (!valuesChanged)
                    return;
            }
            else {
                // Use JSON comparison to handle array fields ([] !== [] by reference but are semantically
                // equal). Without this, dispatching value:[] when current is [] sets loading=true but the
                // React Query key never changes, leaving the loading spinner stuck forever.
                if (JSON.stringify(draft.filters.values[action.field]) ===
                    JSON.stringify(action.value))
                    return;
                if (action.field === 'technicianTeam') {
                    draft.selectedTechnicianIds = [];
                    draft.selectedSubcontractorIds = [];
                }
                draft.filters.values[action.field] = action.value;
            }
            draft.loading = true;
            break;
        case actionTypes.FILTER_TOGGLED:
            draft.filters.active[action.field] =
                !draft.filters.active[action.field];
            if (action.field === 'technicianTeam') {
                draft.selectedTechnicianIds = [];
                draft.selectedSubcontractorIds = [];
            }
            if (action.field === 'statuses') {
                draft.filters.values.inspectionStatusKeys = [];
                draft.filters.values.visitStatusKeys = [];
            }
            else {
                draft.filters.values[action.field] = Array.isArray(draft.filters.values[action.field])
                    ? []
                    : '';
            }
            break;
        case actionTypes.STATUS_TOGGLED:
            draft.statuses[action.field] = !draft.statuses[action.field];
            break;
        case actionTypes.TECH_TOGGLED:
            draft.unselectedTechs[action.value] = !action.checked;
            break;
        case actionTypes.UNSELECT_ALL_TECHS:
            draft.technicians.forEach((tech) => {
                draft.unselectedTechs[tech.value] = true;
            });
            break;
        case actionTypes.SET_TECHNICIANS:
            draft.selectedTechnicianIds = action.ids;
            break;
        case actionTypes.SET_SUBCONTRACTORS:
            draft.selectedSubcontractorIds = action.ids;
            break;
        case actionTypes.UPDATE_TECHNICIANS:
            draft.technicians = action.technicians;
            break;
        case actionTypes.SELECT_ALL_TECHS:
            draft.unselectedTechs = {};
            break;
        case actionTypes.UNSELECT_ALL_STATUSES:
            draft.statuses = {};
            break;
        case actionTypes.UNSELECT_ALL_INSPECTION_STATUSES:
            draft.statuses = Object.keys(Object.assign({}, draft.statuses)).reduce((result, key) => {
                if (!key.startsWith(EntityTypePrefix.Inspection)) {
                    result[key] = draft.statuses[key];
                }
                return result;
            }, {});
            break;
        case actionTypes.UNSELECT_ALL_VISIT_STATUSES:
            draft.statuses = Object.keys(Object.assign({}, draft.statuses)).reduce((result, key) => {
                if (!key.startsWith(EntityTypePrefix.Visit)) {
                    result[key] = draft.statuses[key];
                }
                return result;
            }, {});
            break;
        case actionTypes.SELECT_ALL_STATUSES:
            action.inspectionStatusesForSelect.forEach((status) => {
                draft.statuses[`Inspection${status.value}`] = true;
            });
            action.visitStatusesForHighlight.forEach((status) => {
                draft.statuses[`Visit${status.value}`] = true;
            });
            break;
        case actionTypes.DATA_CHANGED: {
            const index = draft.events.findIndex((event) => event.id === action.event.id);
            draft.events[index] = action.event;
            break;
        }
        case actionTypes.MULTI_DATA_CHANGED: {
            const changedEventsMap = new Map(action.events.map((event) => [event.id, event]));
            draft.events = draft.events.map((event) => changedEventsMap.get(event.id) || event);
            break;
        }
        case actionTypes.MULTI_DATA_DELETED: {
            draft.events = draft.events.filter((event) => !action.eventIds.includes(event.id));
            break;
        }
        case actionTypes.DATA_ADDED: {
            draft.events.push(...action.events);
            break;
        }
        case actionTypes.NETWORK_REQUEST_FAILED:
            draft.errorMessage = action.errorMessage;
            break;
        case actionTypes.DATA_LOADED:
            draft.events = action.data.events;
            draft.loading = false;
            break;
        case actionTypes.LOADING_CHANGED:
            draft.loading = action.loading;
            break;
        default:
            throw new Error('Reducer - Wrong action type.');
    }
});
